import { useParams } from "react-router-dom";

export const useProjectId = () => {
  const params = useParams();
  return params.projectId as string;
};
